import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { AssociationSubjectComponent } from './association-subject/association-subject.component';
import { AssociationBuildingComponent } from './association-building/association-building.component';
import { AssociationSubjectV2Component } from './association-subject-v2/association-subject-v2.component';
import { AssociationBuildingV2Component } from './association-building-v2/association-building-v2.component';
import { WorkflowConfiguratorComponent } from './workflow-configurator/workflow-configurator.component';
import { RequestSearchPracticeRequestComponent } from './request-search-practice-request/request-search-practice-request.component';
import { RequestLinkPracticeComponent } from './request-link-practice/request-link-practice.component';
import { PracticeHistoryComponent } from './practices-history/practices-history.component';
import { RequestFormComponent } from './request-form/request-form.component';
import { RequestDocumentManagerComponent } from './request-document-manager/request-document-manager.component';
import { PracticeWorkflowManagerComponent } from './practice-workflow-manager/practice-workflow-manager.component';
import { CrmDocumentManagerComponent } from './crm-document-manager/crm-document-manager.component';
import { PracticeButtonComplaintOpeningComponent } from './practice-button-complaint-opening/practice-button-complaint-opening.component';
import { RequestCloseButtonComponent } from './request-close-button/request-close-button.component';
import { RequestCancelButtonComponent } from './request-cancel-button/request-cancel-button.component';
import { ChangeStateButtonComponent } from './change-state-button/change-state-button.component';
import { PracticeStateMigrationComponent } from './practice-state-migration/practice-state-migration.component';
import { PlanningButtonSetNonProgrammableComponent } from './planning-button-set-non-programmable/planning-button-set-non-programmable.component';
import { PlanningButtonRestorePreviuousStateComponent } from './planning-button-restore-previuous-state/planning-button-restore-previuous-state.component';
import { RequestCustomerContactedButtonComponent } from './request-customer-contacted-button/request-customer-contacted-button.component';
import { GenericFileUploaderComponent } from './generic-file-uploader/generic-file-uploader.component';
import { FullTextSearchModule } from '../fulltextsearch2/fulltextsearch.module';
import { SharedModule } from '../shared/shared.module';
import { ModalCloseRequest } from './modals/modal-close-request/modal-close-request.component'
import { GenericModal } from './modals/generic-modal/generic-modal.component'
import { IframeModal } from './modals/iframe-modal/iframe-modal.component'
import { ComponentsFileUploadModalComponent } from './modals/components-file-upload-modal/components-file-upload-modal.component'
import { FileDocumentTypeTableComponent } from './modals/components-file-upload-modal/file-document-type-table/file-document-type-table.component'
import { SelectTemplateDialogComponent } from './modals/components-file-upload-modal/file-document-type-table/select-template-dialog/select-template-dialog.component'
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { RequestActionButtonsComponent } from './request-action-buttons/request-action-buttons.component';
import { PracticeActionButtonsComponent } from './practice-action-buttons/practice-action-buttons.component';
import { AddSignalerButtonComponent } from './add-signaler-button/add-signaler-button.component';
import { SignalerModal } from './modals/signaler-modal/signaler-modal.component';
import { ChangeSingleStateButtonComponent } from './change-single-state-button/change-single-state-button.component';
import { PracticeChangeSalesManagerComponent } from './practice-change-sales-manager/practice-change-sales-manager.component';
import { ChangeSalesManagerModal } from './modals/change-sales-manager-modal/change-sales-manager-modal.component';
import { AddSubjectToPracticeButtonComponent } from './add-subject-to-practice-button/add-subject-to-practice-button.component';
import { SubjectToPracticeModal } from './modals/subject-to-practice-modal/subject-to-practice-modal.component';
import { RequestEditFieldsButtonComponent } from './request-edit-fields-button/request-edit-fields-button.component';
import { EditFieldsModal } from './modals/edit-fields-modal/edit-fields-modal.component';
import { SubjectEditFieldsButtonComponent } from './subject-edit-fields-button/subject-edit-fields-button.component';

import { GoogleMapsModule } from '@angular/google-maps';

import { CrmFormComponent } from './crm-form/crm-form.component';
import { CrmFormDataComponent } from './crm-form/crm-form-data/crm-form-data.component';
import { CrmFormDialogComponent } from './crm-form/crm-form-dialog/crm-form-dialog.component';
import { CrmFormDocumentsComponent } from './crm-form/crm-form-documents/crm-form-documents.component';
import { CrmFormLocalizationComponent } from './crm-form/crm-form-localization/crm-form-localization.component';
import { CrmFormMarketingComponent } from './crm-form/crm-form-marketing/crm-form-marketing.component';
import { CrmFormPracticesComponent } from './crm-form/crm-form-practices/crm-form-practices.component';
import { CrmFormRelationsComponent } from './crm-form/crm-form-relations/crm-form-relations.component';
import { CrmFormTypeRadioComponent } from './crm-form/crm-form-type-radio/crm-form-type-radio.component';
import { PracticeChangeCompanyComponent } from './practice-change-company/practice-change-company.component';
import { ChangeCompanyModal } from './modals/change-company-modal/change-company-modal.component';
import { SubjectExtendedSearchComponent } from './subject-extended-search/subject-extended-search.component';
import { SubjectSectionSearchDialogComponent } from '../subject-section/subject-section-search-dialog/subject-section-search-dialog.component';
import { BuildingExtendedSearchComponent } from './building-extended-search/building-extended-search.component';
import { BuildingSectionSearchDialogComponent } from '../building-section/building-section-search-dialog/building-section-search-dialog.component';
import { BuildingMapSearchDialogComponent } from './building-map-search-dialog/building-map-search-dialog.component';
import { MatSliderModule } from '@angular/material/slider';

import { GenericIframeModal } from './modals/generic-iframe-modal/generic-iframe-modal.component'

const MATERIAL_MODULES = [
  MatTableModule,
  MatPaginatorModule,
  MatButtonModule,
  MatSortModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatExpansionModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatCardModule,
  FullTextSearchModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatListModule,
  MatGridListModule,
  MatRadioModule,
  MatTabsModule,
  MatBadgeModule,
  MatSliderModule,
]

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AssociationSubjectComponent,
    AssociationBuildingComponent,
    AssociationSubjectV2Component,
    AssociationBuildingV2Component,
    WorkflowConfiguratorComponent,
    RequestFormComponent,
    RequestDocumentManagerComponent,
    PracticeWorkflowManagerComponent,
    CrmDocumentManagerComponent,
    PracticeButtonComplaintOpeningComponent,
    GenericFileUploaderComponent,
    RequestCloseButtonComponent,
    RequestCancelButtonComponent,
    ChangeStateButtonComponent,
    ChangeSingleStateButtonComponent,
    PracticeStateMigrationComponent,
    PlanningButtonSetNonProgrammableComponent,
    PlanningButtonRestorePreviuousStateComponent,
    RequestCustomerContactedButtonComponent,
    ModalCloseRequest,
    GenericModal,
    IframeModal,
    GenericIframeModal,
    ComponentsFileUploadModalComponent,
    FileDocumentTypeTableComponent,
    SelectTemplateDialogComponent,
    RequestSearchPracticeRequestComponent,
    RequestLinkPracticeComponent,
    PracticeHistoryComponent,
    RequestActionButtonsComponent,
    PracticeActionButtonsComponent,
    AddSignalerButtonComponent,
    SignalerModal,
    PracticeChangeSalesManagerComponent,
    ChangeSalesManagerModal,
    AddSubjectToPracticeButtonComponent,
    SubjectToPracticeModal,
    RequestEditFieldsButtonComponent,
    EditFieldsModal,
    SubjectEditFieldsButtonComponent,
    CrmFormComponent,
    CrmFormDataComponent,
    CrmFormDialogComponent,
    CrmFormDocumentsComponent,
    CrmFormLocalizationComponent,
    CrmFormMarketingComponent,
    CrmFormPracticesComponent,
    CrmFormRelationsComponent,
    CrmFormTypeRadioComponent,
    PracticeChangeCompanyComponent,
    ChangeCompanyModal,
    SubjectExtendedSearchComponent,
    SubjectSectionSearchDialogComponent,
    BuildingExtendedSearchComponent,
    BuildingSectionSearchDialogComponent,
    BuildingMapSearchDialogComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    GooglePlaceModule,
    FormsModule,
    HttpClientModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    GoogleMapsModule,
    TranslateModule.forChild(
      {
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        },
      }
    ),
    MATERIAL_MODULES
  ],
  exports: [
    AssociationSubjectComponent,
    AssociationBuildingComponent,
    AssociationSubjectV2Component,
    AssociationBuildingV2Component,
    WorkflowConfiguratorComponent,
    RequestFormComponent,
    RequestDocumentManagerComponent,
    PracticeWorkflowManagerComponent,
    CrmDocumentManagerComponent,
    PracticeButtonComplaintOpeningComponent,
    GenericFileUploaderComponent,
    RequestCloseButtonComponent,
    RequestCancelButtonComponent,
    ChangeStateButtonComponent,
    ChangeSingleStateButtonComponent,
    PracticeStateMigrationComponent,
    PlanningButtonSetNonProgrammableComponent,
    PlanningButtonRestorePreviuousStateComponent,
    RequestCustomerContactedButtonComponent,
    ModalCloseRequest,
    GenericModal,
    IframeModal,
    GenericIframeModal,
    ComponentsFileUploadModalComponent,
    FileDocumentTypeTableComponent,
    SelectTemplateDialogComponent,
    RequestSearchPracticeRequestComponent,
    RequestLinkPracticeComponent,
    PracticeHistoryComponent,
    RequestActionButtonsComponent,
    PracticeActionButtonsComponent,
    AddSignalerButtonComponent,
    SignalerModal,
    PracticeChangeSalesManagerComponent,
    ChangeSalesManagerModal,
    AddSubjectToPracticeButtonComponent,
    SubjectToPracticeModal,
    RequestEditFieldsButtonComponent,
    EditFieldsModal,
    SubjectEditFieldsButtonComponent,
    CrmFormComponent,

    CrmFormDataComponent,
    CrmFormDialogComponent,
    CrmFormDocumentsComponent,
    CrmFormLocalizationComponent,
    CrmFormMarketingComponent,
    CrmFormPracticesComponent,
    CrmFormRelationsComponent,
    CrmFormTypeRadioComponent,
    PracticeChangeCompanyComponent,
    ChangeCompanyModal,
    SubjectExtendedSearchComponent,
    SubjectSectionSearchDialogComponent,
    BuildingExtendedSearchComponent,
    BuildingSectionSearchDialogComponent,
    BuildingMapSearchDialogComponent,
  ]
})
export class ComponentsModule { }
